const x = document.querySelector('.upload-area');

// const z = document.getElementsByTagName('input');


// x?.addEventListener('click', ()=> {

    
// })

export{}